import { api } from '@/api';

export interface GetChatDocumentInfoRequest {
  chatId: string;
  documentIds: string[];
}

/** Single id -> name mapping entry returned by `/chat/document-info`. */
export interface ChatDocumentInfoEntry {
  name: string;
  /** Present when the backend knows the document cannot be previewed. */
  isDisplayable?: boolean;
}

export interface GetChatDocumentInfoResponse {
  /** Keyed by document UUID. */
  documentInfo: Record<string, ChatDocumentInfoEntry>;
}

const getChatDocumentInfoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatDocumentInfo: builder.query<GetChatDocumentInfoResponse, GetChatDocumentInfoRequest>({
      query: ({ chatId, documentIds }) => ({
        url: '/chat/document-info',
        method: 'GET',
        params: { chatId, fletchDocumentIds: documentIds },
      }),
    }),
  }),
});

export const { useGetChatDocumentInfoQuery } = getChatDocumentInfoApi;
